class HamburgerMenu {
    constructor () {
        this.menuIsOperating = false;
        this.windowPosition;
        this.hambugerButton = document.getElementById('hambugerButton');
        this.navMenu = document.getElementById('navMenu');
        this.body = document.querySelector('body');
        this.bodyOverlay = document.getElementById('bodyOverlay');


        if(this.hambugerButton) {
            this.events();
        }

    }

    // ============
    // Events
    // =============
    events() {
        this.hambugerButton.addEventListener('click', (e) => this.handleMenuOpen(e));
        window.addEventListener('resize', () => {
            if(this.menuIsOperating && matchMedia("(min-width: 992px)").matches) {
                this.reset();
            }
        } )
    }

    // ============
    // Methods
    // =============
    
    //メニューを開く 
    handleMenuOpen(event) {
        this.menuIsOperating = true;

        event.preventDefault();
        this.bodyOverlay.classList.toggle('is-visible');
        this.navMenu.classList.toggle('is-visible');

        this.monitorMenuOperation();
        this.handleBodyfixing();
    }

    // メニューが開いてるかどうかを監視
    monitorMenuOperation() {
        if(this.navMenu.classList.contains('is-visible')) {
            this.menuIsOperating = true;
        }else {
            this.menuIsOperating = false;
        }
    }

    // bodyのスクロールを固定する
    handleBodyfixing() {
        if(this.menuIsOperating) {
            this.windowPosition = window.scrollY;
            this.body.classList.add('is-fixed');
            this.body.style.top = `-${this.windowPosition}px`
        }else {
            this.body.classList.remove('is-fixed');
            this.body.style.top = "";
            window.scrollTo({left: 0, top: this.windowPosition, behavior:'instant'});
        }
    }

    // 全ての処理をリセットして、メニューを閉じる
    reset() {
        this.navMenu.classList.remove('is-visible');
        this.bodyOverlay.classList.remove('is-visible');

        this.menuIsOperating = false;
    }
}


export default HamburgerMenu;
